import { pump_registry } from "./pump_registry";
import { generate_pump_vibration_block } from "./generate_pump_vibration_block";
import {
    formatDateTime,
    random,
    round2,
    getMinutesPassedToday,
    getMinutesPassedThisMonth,
} from "../helpers/helpers";

export const generate_pump_latest_data_demo = ({ meter_id }) => {
    const pump = pump_registry.find(p => p.meter_id === Number(meter_id));
    if (!pump) return null;

    /* ---------------- TIME CALCULATION ---------------- */
    const todayMinutes = getMinutesPassedToday();
    const monthMinutes = getMinutesPassedThisMonth();

    // realistic utilization
    const dailyRunningMin = Math.round(todayMinutes * random(0.7, 0.9));
    const dailyIdleMin = todayMinutes - dailyRunningMin;

    const monthlyRunningMin = Math.round(monthMinutes * random(0.65, 0.85));
    const monthlyIdleMin = monthMinutes - monthlyRunningMin;

    // convert minutes → hours (rounded)
    const total_running_time = Math.round(dailyRunningMin / 12);
    const total_idle_time = Math.round(dailyIdleMin / 12);
    const total_off_time = 0;

    const total_running_month_time = Math.round(monthlyRunningMin / 60);
    const total_idle_month_time = Math.round(monthlyIdleMin / 60);
    const total_off_month_time = Math.round(monthMinutes * random(0.05, 0.1) / 60);

    /* ---------------- RESPONSE ---------------- */
    return {
        meter_id: pump.meter_id,
        meter_name: pump.meter_name,
        orientation: pump.orientation,

        status: "Online",
        pump_status: "On",
        pump_current_status: "On",

        pump_status_updated_on: formatDateTime(
            new Date(Date.now() - random(1, 3) * 24 * 60 * 60 * 1000)
        ),
        dtime: formatDateTime(new Date()),

        suction_pressure: round2(random(1.4, 2.6)),
        discharge_pressure: round2(random(4.0, 6.2)),
        efficiency: round2(random(68, 85)),
        hydraulic_power: round2(random(15, 28)),

        /* ----------- TIME STATS ----------- */
        total_running_time,
        total_idle_time,
        total_off_time,

        total_running_month_time,
        total_idle_month_time,
        total_off_month_time,

        water_flow: {
            flow_rate: round2(random(250, 450)),
            last_sync_time: formatDateTime(new Date()),
        },

        energy_meter: {
            avg_current: round2(random(40, 90)),
            total_active_power: round2(random(200, 500)),
            last_sync_time: formatDateTime(new Date()),
        },

        daily_data_active_energy: null,
        monthly_data_active_energy: round2(random(1200, 2400)).toFixed(2),

        bearing_vibration: generate_pump_vibration_block(),
        de_vibration: generate_pump_vibration_block(),
        nde_vibration: generate_pump_vibration_block(),
    };
};